export enum RaceOptions {
	AmericanIndianOrAlaskaNative = 'americanIndianOrAlaskaNative',
	Asian = 'asian',
	BlackOrAfricanAmerican = 'blackOrAfricanAmerican',
	HispanicOrLatin = 'hispanicOrLatin',
	NativeHawaiianOrOtherPacificIslander = 'nativeHawaiianOrOtherPacificIslander',
	White = 'white',
	Other = 'other',
}
